module.exports = __webpack_public_path__ + "img/ph_1.9f690b62.jpg";